// Sessão da área do afiliado (/{idioma}/afiliado), separada da do assinante
// (stores/jwt.ts e stores/user.ts): outro token, outra chave no localStorage, sem
// refresh. O token só vale na API da área (claim `area = afiliado`).

export type PerfilAfiliado = {
  codigo: number;
  nome: string;
  primeiro_nome: string;
  desde: string;
  idioma: "pt-br" | "en";
  link_divulgacao: string;
  link_assine: string;
};

export const afiliadoStore = defineStore("afiliado", {
  state: () => ({
    token: "" as string,
    perfil: null as PerfilAfiliado | null,
    // Mensagem para o login mostrar depois que a sessão cai (token vencido,
    // cadastro desativado). Não é persistida.
    aviso: "" as string,
  }),
  getters: {
    logado: (state): boolean => !!state.token,
  },
  actions: {
    entrar(token: string, perfil: PerfilAfiliado) {
      this.token = token;
      this.perfil = perfil;
      this.aviso = "";
    },
    atualizarPerfil(perfil: PerfilAfiliado) {
      this.perfil = perfil;
    },
    limpar(aviso = "") {
      this.token = "";
      this.perfil = null;
      this.aviso = aviso;
    },
    consumirAviso(): string {
      const aviso = this.aviso;
      this.aviso = "";
      return aviso;
    },
  },
  persist: {
    key: "afiliado",
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ["token", "perfil"],
  },
});
